export interface ITopBarPropsChildren {
    label: string;
    href: string;
    icon?: string;
}

export interface ITopBarProps {
    label: string;
    href: string;
    userOnly: boolean;
    children: ITopBarPropsChildren[];
}

const topBarProps: { pages: ITopBarProps[] } = {
    pages: [
        {
            label: "Library",
            href: "/library",
            userOnly: true,
            children: [],
        },
        {
            label: "Community",
            href: "/community",
            userOnly: false,
            children: [],
        },
        {
            label: "Support",
            href: "/support",
            userOnly: false,
            children: [
                { label: "Contact Us", href: "/contact", icon: "/images/birdcellphone.jpeg" },
                { label: "FAQ", href: "/faq", icon: "/images/birdthought.jpeg" },
            ],
        },
    ],
};

export default topBarProps;
